import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "./commonSlice";
import settingsReducer from "./settingsSlice";

export const store = configureStore({
    reducer: {
        common: commonReducer,
        settings: settingsReducer
    }
})